/**
 * Utility functions for replacing placeholders in assessment question texts
 */

import type { AssessmentUserSummary } from '../types/assessment.types'

type Employee = NonNullable<AssessmentUserSummary>

/**
 * Replace organization name placeholder in text
 */
export function replaceOrganizationName(
  text: string,
  organizationName: string,
): string {
  return text.replace(/{organization_name}/g, organizationName)
}

/**
 * Replace manager-specific placeholders (first_name, etc.) in text
 */
export function replaceManagerPlaceholders(
  text: string,
  employee: Employee | null,
  organizationName: string,
): string {
  if (!employee) return replaceOrganizationName(text, organizationName)

  const name = employee.name ?? employee.email
  const firstName = name.split(' ')[0] || name

  return text
    .replace(/{first_name}/g, firstName)
    .replace(/{organization_name}/g, organizationName)
}

/**
 * Replace placeholders in question text based on context
 */
export function replacePlaceholders(
  text: string,
  options: {
    isEmployee: boolean
    employee: Employee | null
    organizationName: string
  },
): string {
  const { isEmployee, employee, organizationName } = options

  if (isEmployee) {
    return replaceOrganizationName(text, organizationName)
  }

  return replaceManagerPlaceholders(text, employee, organizationName)
}
